import React,{useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store/reducers';
import { AppThunkDispatch } from '../../modules/thunk';
import { getNotificationDetails } from '../../modules/notification';
import { tracking } from '../../services';
import newRelicData from '../../newrelic';
import { getEmail } from '../../modules/customer';

/**
 * Error Update
 */
function ErrorDetails() {
    const fullState = useSelector((state: RootState) => state);
    const dispatch: AppThunkDispatch = useDispatch();
    const notificationDetails = getNotificationDetails(fullState, dispatch);
    const customer = useSelector((state: RootState) => state.customer);
    const email = getEmail(customer);
    const formattedEmail = email.slice(email.indexOf('@') - 4);

    useEffect(() => {
        if(notificationDetails.message !== '')
        {
            tracking()?.trackError(notificationDetails.code, notificationDetails.message); 
            newRelicData({ actionName: notificationDetails.action, userFunction: 'errorDetails', message: notificationDetails.message, customerEmail: formattedEmail, result: 'error' });
        }
    // eslint-disable-next-line
    }, [notificationDetails.message]);

    return <></>;

}

export default ErrorDetails;
